import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BookingFlow from '../components/BookingFlow';
import SquarePayment from '../components/SquarePayment';

const PaymentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [bookingData, setBookingData] = useState(null);
  const [showFullFlow, setShowFullFlow] = useState(true);

  useEffect(() => {
    // Check if booking data was passed from previous step
    if (location.state?.bookingData) {
      setBookingData(location.state.bookingData);
      setShowFullFlow(false);
    }
  }, [location.state]);

  const handleBookingComplete = (result) => {
    console.log('Booking completed successfully:', result);
    
    // Navigate to thank you page with booking details
    navigate('/order-complete', {
      state: {
        bookingRefId: result.bookingRefId,
        paymentResult: result.payment,
        bookingData: result.booking
      }
    });
  };

  const handleError = (error) => {
    console.error('Booking/Payment error:', error);
    // You can add toast notifications or other error handling here
  };

  // If we have existing booking data, show only payment component
  if (bookingData && !showFullFlow) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Complete Payment</h1>
            <p className="text-gray-600">Secure payment powered by Square</p>
          </div>

          <SquarePayment
            bookingRefId={bookingData.booking_ref_id}
            amount={parseFloat(bookingData.final_fare)}
            passengerId={bookingData.passenger_id}
            paymentType={bookingData.payment_type || 'FULL'}
            onSuccess={(paymentResult) => {
              handleBookingComplete({
                booking: bookingData,
                payment: paymentResult,
                bookingRefId: bookingData.booking_ref_id,
                passengerId: bookingData.passenger_id
              });
            }}
            onError={handleError}
          />

          <div className="max-w-md mx-auto text-center mt-6">
            <button
              onClick={() => navigate(-1)}
              className="text-blue-600 hover:text-blue-800 text-sm"
            >
              ← Back to booking details
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Show full booking flow
  return (
    <BookingFlow
      initialBookingData={bookingData || {}}
      onBookingComplete={handleBookingComplete}
      onError={handleError}
    />
  );
};

export default PaymentPage;
